<template>
   <div class="common-relatives common-items-center iconImg">
      <div class="showImng" v-if="!!imgIcon">
         <div class="warpIcon">
            <svg-icon :icon="imgIcon" class="icon" />
         </div>
      </div>
      <el-select v-model="value" :popper-append-to-body="false" :placeholder="!imgIcon ? placeholder : ''" :style='{ width: width + "px" }'>
         <el-option :key="item.value" :label="item.label" :value="item.value" v-for="item in options">
            <div class="block" :style='{ width: width + "px" }'>
               <span class="warp-img" v-for="(item, index) in list" :key="index" @click="getVal(item)">
                  <svg-icon :icon="item"  />
                  <!-- <div class="text">{{item | TutOutB}}</div> -->
               </span>
            </div>
         </el-option>
      </el-select>
   </div>
</template>
<script>
import { Iconimg } from '../../utils/util'
export default {
   data: () => ({
      options: [ {value: 'HTML',label: 'HTML'}],
      value: "",
      list: [],
      placeholder: "请选择ICON",
      imgIcon: ""
   }),
   created() {
      // this.list = [Iconimg()[0]] 
      this.list = Iconimg()
   },
   props: {
      width: {
         type: String,
         default: "327",
      },
      keyVal: {
         type: String,
         default: "",
      }
   },
   mounted() {

   },
   methods: {
      getVal(ev) {
         console.log(ev)
         this.imgIcon = ev
         this.$emit("getVal", ev)
      },
      setVal(ev) {
         this.imgIcon = ev
      },
   }
}
</script>
<style lang="scss" scoped>
.iconImg {
    position: relative;

    .showImng {
       height: 94%;
       width: 80%;
       position: absolute;
       top: 1px;
       left:2px;
       z-index: 10;
       pointer-events: none;
       display: flex;
       align-items: center;
       background-color: white;
       .warpIcon{
          width: 30px;
          height: 30px;
          position: relative;
          overflow: hidden;
          margin-left:5px;
          z-index: 10;
          border-radius: 4px;
       }
       .icon {
          font-size: 70px;
          position: absolute;
          top: -20px;
          right: -2px;
       }
    }

    ::v-deep .el-scrollbar {
       height: 274px;
    }

    ::v-deep .el-scrollbar__wrap {
       height: 274px;
    }

    ::v-deep .el-select-dropdown__item {
       height: 274px;
       padding: 0;
    }

    ::v-deep .el-select-dropdown__lis {
       padding: 0 !important;
       height: 274px;
    }
    ::v-deep .el-select-dropdown__list{
      padding: 0;
      height: 274px;
    }

    .block {
       padding: 5px 0px 10px 2px;
       box-sizing: border-box;
       height:274px;
       overflow-y: auto;
       display: flex;
       align-content: flex-start;
       flex-wrap: wrap;
       background-color: white;
       line-height: 40px;
       .warp-img {
          display: inline-block;
          height:30px;
          width: 30px;
          border: 1px solid #B4B4B4;
          margin-left: 5px;
          margin-bottom: 5px;
          border-radius: 4px;
          overflow: hidden;
          position: relative;
          .svg-icon{
            font-size: 78px;
            position: absolute;
            top: -24px;
            right: -5px;
         }
         // .text{
         //    position: absolute;
         //    top:18px;
         //    left:-9px;
         //    transform: scale(0.7);
         // }
      }
    }
 }
</style>